import { useFlag } from '@simplywallst/unleash';
import useUser from '@/hooks/useUser';
import { useUserAccess } from '@/hooks/useUserAccess';
import { checkAprilPromo } from './utils';
import { ROUTE_PRIVACY_POLICY_FULL } from '@/constants/routes';
import { ROUTE_PRIVACY_POLICY } from '@/constants/routes';
import {
  ROUTE_CAREERS,
  ROUTE_TERMS_AND_CONDITIONS,
  ROUTE_TERMS_AND_CONDITIONS_FULL,
} from '@/constants/routes';
import { ROUTE_ABOUT, ROUTE_PLANS } from '@/constants/routes';
import { ROUTE_USER_LOGOUT } from '@/constants/routes';
import { ROUTE_WELCOME } from '@/constants/routes';
import { useLocation } from '@/hooks/useLocation';
import { useGetPlanTypeFromStorage } from '@/hooks/usePersistPlanType';

type UseApril2025Promo = {
  isPromoActive: boolean;
  variant: string | null;
};

/**
 * Promo for April 2025
 * Variant types:
 * default / endingSoon / lastChance
 */
export const useApril2025Promo = (): UseApril2025Promo => {
  const flag = useFlag('mono-april-2025-promo');
  const { type } = useLocation();
  const { data: user, queryStatus: userQueryStatus } = useUser();
  const { data: userAccess, status: userAccessStatus } = useUserAccess();
  const { guestPlanType } = useGetPlanTypeFromStorage();

  if (
    [
      ROUTE_WELCOME,
      ROUTE_USER_LOGOUT,
      ROUTE_PLANS,
      ROUTE_ABOUT,
      ROUTE_CAREERS,
      ROUTE_TERMS_AND_CONDITIONS,
      ROUTE_TERMS_AND_CONDITIONS_FULL,
      ROUTE_PRIVACY_POLICY,
      ROUTE_PRIVACY_POLICY_FULL,
    ].includes(type) ||
    userQueryStatus === 'pending' ||
    userAccessStatus === 'pending' ||
    !flag.ready
  ) {
    return {
      isPromoActive: false,
      variant: null,
    };
  }

  const isPromoActive =
    flag.enabled &&
    flag.variant.name !== 'control' &&
    checkAprilPromo({
      loggedIn: user.loggedIn,
      couponId: user.billing.coupon.id,
      userAccessPlanType: userAccess.planType,
      guestPlanType,
    });

  return {
    isPromoActive,
    variant: flag.variant.name,
  };
};
